<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image4" /> -->
    <!-- this background image diabled. background image add to app.vue file -->
    <transition appear
                @before-enter="$animations.beforeEnterLogoArea"
                @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>

    <transition appear
                @before-enter="$animations.beforeEnterAbove"
                @enter="$animations.enterAbove"
    >
      <div class="columns mb-0 is-centered">
        <div
          v-if="$root.selectedLanguage === `en`"
          class="column"
          style="text-align: center"
        >
          <img class="progress-bar is-offset-one-fifth"
            src="../assets/images/icons/RBDSecondheaderImagesEng/Group 289353.png"
            alt="businessInfo.png"
            width="70%"
          />
        </div>
        <div
          v-if="$root.selectedLanguage === `si`"
          class="column"
          style="text-align: center"
        >
          <img
            src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37574.png"
            alt="businessInfo.png"
            width="70%"
          />
        </div>
      </div>
    </transition>
<!-- card added and wrap elements here -->
    <div class="card px-4" style="width: 80%; margin: 20px auto;">
    <transition appear
                @before-enter="$animations.beforeEnterAbove"
                @enter="$animations.enterAbove"
    >
      <div class="columns is-centered">
        <div class="column is-half ps-5" style="text-align: center">
          <img
            src="../assets/images/icons/Blue/Group 157.png"
            alt="business-info-img"
            class="margin-top: 5%"
            width="50"
            height="50"
          />
          <p
            :class="`text-center mx-3 ${
              $root.selectedLanguage === `ta`
                ? `ta-he-line`
                : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
            }`"
          >
            {{ $root.selectedLanguageData.businessInfo }}
          </p>
          <p
            :class="`text-center mx-3 ${
              $root.selectedLanguage === `ta`
                ? `ta-sub-line`
                : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
            }`"
          >
            {{
              $root.selectedLanguageData.tellUsMoreAboutYourBusinessOrEmployment
            }}
          </p>
          <p>
            {{ $root.selectedLanguageData.dataEditByButton }}
          </p>
        </div>
      </div>
    </transition>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="onSubmit">
        <div class="columns is-centered">
          <transition appear
                      @before-enter="$animations.beforeEnterBelow"
                      @enter="$animations.enterBelow"
          >
            <div class="column is-half pt-5 ps-5">
            <!-- <div>
              <label>
                {{ $root.selectedLanguageData.natureOfEmployment
                }}<span
                  class="has-text-danger"
                  v-if="
                    $root.formData.purposeOfOpeningtheAccount ===
                    `Business Transaction`
                  "
                  >*</span
                ></label
              >
              <div class="field mb-5">
                <div>
                  <ValidationProvider
                    :rules="natureOfEmploymentValidation()"
                    v-slot="{ errors }"
                  >
                    <div style="width: 100%">
                      <b-select
                        v-model="$root.formData.natureOfEmployment"
                        expanded
                        rounded
                      >
                        <option
                          v-for="natureOfEmployment in $root
                            .selectedLanguageData.natureOfEmployments"
                          :key="natureOfEmployment.natureOfEmployment"
                          :value="natureOfEmployment.natureOfEmployment"
                        >
                          {{ natureOfEmployment.natureOfEmployment }}
                        </option>
                      </b-select>
                    </div>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div> -->
            <div v-if="$root.kycFieldVisibility.employment_position">
              <label
                :class="`${
                  $root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                }`"
              >
                {{ $root.selectedLanguageData.occupationDesignation
                }}<span class="has-text-danger">*</span></label
              >
              <div class="field mb-5">
                <div>
                  <div style="width: 100%">
                    <b-field>
                      <p class="control has-icons-right">
                        <b-autocomplete
                         
                          v-model="occupation"
                          :data="filteredDataArray"
                          open-on-focus
                          :placeholder="$root.selectedLanguageData.searchAnOccupation"
                          icon="magnify"
                          @focus="$inputFocused('employment_position')"
                          @input="
                            () => {
                              $inputChanged('employment_position');
                              isOccupationTouched = true;
                            }
                          "
                          @blur="$inputBlured('employment_position')"
                          clearable
                          @select="
                            (option) => {
                              $root.formData.employment_position = option;
                            }
                          "
                        >
                        </b-autocomplete>
                        <span class="icon is-small is-right mr-2">
                          <img
                            src="../assets/images/icons/Blue/Stroke.png"
                            alt="Stroke-img"
                            width="13"
                            height="13"
                          />
                        </span>
                      </p>
                    </b-field>
                  </div>
                  <span
                    v-if="
                      isOccupationTouched && !$root.formData.employment_position
                    "
                    class="has-text-danger"
                    >Occupation/Designation is required</span
                  >
                </div>
              </div>
            </div>
            <div v-if="$root.kycFieldVisibility.employer_name">
              <label
                :class="`${
                  $root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                }`"
              >
                {{ $root.selectedLanguageData.nameofEmployerBusiness }}</label
              >
              <div class="field mb-5">
                <ValidationProvider
                  :rules="{ noNumbers: true }"
                  name="This field"
                  v-slot="{ errors }"
                >
                  <p class="control has-icons-right">
                    <b-input
                      
                      type="text"
                      @focus="$inputFocused('employer_name')"
                      @input="$inputChanged('employer_name')"
                      @blur="$inputBlured('employer_name')"
                      v-model="$root.formData.employer_name"
                    />
                    <span class="icon is-small is-right">
                      <img
                        src="../assets/images/icons/Blue/Group 156.png"
                        alt="contact-name-img"
                        width="25"
                        height="25"
                      />
                    </span>
                  </p>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div v-if="$root.kycFieldVisibility.employer_addr">
              <label
                :class="`${
                  $root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                }`"
              >
                {{ $root.selectedLanguageData.employerBusinessAddress }}</label
              >
              <div class="field mb-5">
                <ValidationProvider
                  :rules="validateOptionalAddress()"
                  name="This field"
                  v-slot="{ errors }"
                >
                  <p class="control has-icons-right">
                    <b-input
                      type="textarea"
                      @focus="$inputFocused('employer_addr')"
                      @input="$inputChanged('employer_addr')"
                      @blur="$inputBlured('employer_addr')"
                      v-model="$root.formData.employer_addr"
                     
                    ></b-input>
                    <span class="icon is-small is-right">
                      <img
                        src="../assets/images/icons/Blue/Location.png"
                        alt="contact-name-img"
                        width="25"
                        height="25"
                      />
                    </span>
                  </p>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <!-- <div v-if="$root.formData.selectmaritalStatus === `Married`">
              <div>
                <label>{{
                  $root.selectedLanguageData.employer_name_spouse
                }}</label>
                <div class="field mb-5">
                  <ValidationProvider
                    :rules="validateOptionalName()"
                    name="This field"
                    v-slot="{ errors }"
                  >
                    <p class="control has-icons-right">
                      <b-input
                        rounded
                        type="text"
                        v-model="$root.formData.employer_name_spouse"
                      />
                      <span class="icon is-small is-right">
                        <img
                          src="../assets/images/icons/Yellow/Group 156.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                        />
                      </span>
                    </p>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div>
                <label>{{
                  $root.selectedLanguageData.employment_position_spouse
                }}</label>
                <div class="field mb-5">
                  <ValidationProvider
                    :rules="{ noNumbers: true }"
                    name="This field"
                    v-slot="{ errors }"
                  >
                    <p class="control has-icons-right">
                      <b-input
                        rounded
                        type="text"
                        v-model="$root.formData.employment_position_spouse"
                      />
                      <span class="icon is-small is-right">
                        <img
                          src="../assets/images/icons/Yellow/Group 156.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                        />
                      </span>
                    </p>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div> -->
          </div>
          </transition>
        </div>

        <transition appear
                    @before-enter="$animations.beforeEnterBelow"
                    @enter="$animations.enterBelow"
        >
          <div class="columns mb-3">
            <div
              class="column is-6 is-offset-3 is-flex is-flex-direction-row-reverse"
            >
              <b-button
                :class="`is-primary  ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"
                :disabled="
                  invalid ||
                  ($root.kycFieldVisibility.employment_position
                    ? !$root.formData.employment_position
                    : false) ||
                  ($root.kycFieldVisibility.employment_position
                    ? $root.formData.employment_position !== occupation
                    : false)
                "
                @click="identityprooftype()"
              >
                {{ $root.selectedLanguageData.continue }}
              </b-button>
              <b-button
                :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"
                @click="$router.go(-1)"
                >{{ $root.selectedLanguageData.back }}</b-button
              >
            </div>
          </div>
        </transition>
      </form>
    </ValidationObserver>
  </div>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>
<script>
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
export default {
  components: {
    GetHelp,
    Logo,
  },
  data() {
    return {
      occupation: "",
      isOccupationTouched: false,
    };
  },
  methods: {
    identityprooftype() {
      const comp = this;
      if (comp.$root.formData.idType === "PNO") {
        comp.$router.push("document_passport");
      } else {
        comp.$router.push("documents_id");
      }
    },
    validateOptionalName: function () {
      const obj = {
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
      };
      return obj;
    },
    validateOptionalAddress: function () {
      const obj = {
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
      };
      return obj;
    },

    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        this.$http
          .post(this.$baseURL + "/kycForm/updateLastStep", {
            last_step: 7,
          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },
    natureOfEmploymentValidation() {
      const obj = {};
      if (this.$root.formData.purpose_of_opening === `Business Transaction`) {
        obj.required = true;
      }
      return obj;
    },
  },
  mounted: function () {
    this.updateLastStep();
    if (this.$root.formData.employment_position) {
      this.occupation = this.$root.formData.employment_position;
    }
  },
  computed: {
    filteredDataArray() {
      return this.$root.selectedLanguageData.occupations.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.occupation.toLowerCase()) >= 0
        );
      });
    },
  },
};
</script>
<style>

@media screen and (max-width: 420px) {

  .progress-bar{

    width: 90%;
    height: 100%;


}

}


</style>
